<template>
  <div :class="'md-layout'">
    <md-dialog :md-active.sync="showing">
      <md-dialog-title>{{ question.text }}</md-dialog-title>
      <md-dialog-content>
        <div :class="'md-layout-item'">
          <md-table table-header-color="orange">
            <md-table-row slot="md-table-row" v-for="(item, i) in files" :key="i">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Sent at">{{
                item.created_at
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="showFile(item)"
                  title="Show file">
                  <md-icon>search</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" :disabled="isDisabled"
                  @click.prevent="tryToDelete(item, i)" title="Remove file">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :class="'md-danger'" @click="showing = false">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="isTryingToDelete">
      <md-dialog-title>Delete file</md-dialog-title>
      <md-dialog-content v-if="deletableFile.name">
        Are you sure you want to delete <b>{{ deletableFile.name }}</b>?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isDeletingFile" @click.prevent="isTryingToDelete = false">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="isDeletingFile" @click.prevent="deleteFile()">
          {{ !isDeletingFile ? "Delete" : "Deleting..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <div :class="'md-layout-item md-size-70'" v-bind:style="answered ? '' : 'color: #ef4225;'">
      {{ question.text }}
    </div>
    <div :class="'md-layout-item md-size-20'">
      <span v-if="files.length === 0 && uploading === false" :class="'text-danger'">
        Pending
      </span>
      <span v-else-if="uploading === true">
        Uploading...
        <md-progress-spinner :class="'md-accent'" :md-diameter="15" :md-stroke="3"
          md-mode="indeterminate"></md-progress-spinner>
      </span>
      <span v-else>
        <div @click.prevent="showing = true" :class="'md-layout-item md-size-10 text-right'"
          :style="'margin-top: -15px !important'">
          <div :class="'button-container'">
            <md-button :class="'md-default md-round md-fileinput md-just-icon'">
              <md-icon>folder</md-icon>
              <md-tooltip md-direction="top">Show selected files</md-tooltip>
            </md-button>
          </div>
        </div>
      </span>
    </div>
    <div :class="'md-layout-item md-size-10 text-right'" :style="'margin-top: -15px !important'">
      <div :class="'file-input'">
        <div :class="'button-container'">
          <md-button :class="'md-default md-round md-fileinput md-just-icon'" :disabled="isDisabled">
            <md-icon>search</md-icon>
            <md-tooltip md-direction="top">Select files</md-tooltip>
            <input type="file" :name="question.field" @change="onFileChange($event)" multiple />
          </md-button>
        </div>
      </div>
    </div>
    <div :class="'md-layout-item md-size-100'">
      <md-field>
        <label>Observation</label>
        <md-input
          type="text"
          v-model="observation"
          :disabled="isDisabled"
          :maxlength="100"
          @change="updateObservation"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    answered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      files: [],
      uploading: false,
      showing: false,
      deletableFile: {},
      deletableIndex: false,
      isTryingToDelete: false,
      isDeletingFile: false,
      showingFile: false,
      observation: '',

      errorResponses: {
        400: "The sent file is invalid",
        422: "There is an error with your file",
      },
    };
  },
  methods: {

    initializeObservation() {
  if (this.answers && this.answers.length > 0) {
    const existingAnswer = this.answers.find(answer => answer.question_id === this.question.id);
    if (existingAnswer && existingAnswer.text) {
      this.observation = existingAnswer.text;
    }
  }
},
    onFileChange(e) {
      const data = {
        section: "manager",
        type: this.question.type,
        answers: [{
          question_id: this.question.id,
          text: this.observation,
        }],
      };

      const id = this.$route.params.id;
      this.uploading = true;

      this.$api.request
        .post(`reviews/${id}/answers`, data)
        .then((response) => {
          this.$emit("post-sent", {
            question: this.question.id || response.data[0]["question_id"],
          });

          Array.from(e.target.files).forEach((file, i) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("answer_id", response.data[0].id);
            formData.append("text", this.observation);

            this.$api.request
              .post("files", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                this.files.push(res.data);
              })
              .catch((error) => {
                if (this.errorResponses[error.response.status]) {
                  this.$toast.show(this.errorResponses[error.response.status]);
                } else {
                  this.$toast.show(
                    "Ops, something went wrong! Please, try again."
                  );
                }
              })
              .finally(() => {
                if (e.target.files.length - 1 === i) {
                  this.uploading = false;
                  e.target.value = "";
                }
              });
          });
        })
        .catch(() => {
          //console.error('Erro ao enviar resposta da questão:', error);
          this.$toast.warning("Please, try again.", "");
          this.uploading = false;
          e.target.value = "";
        });
    },
    tryToDelete(file, i) {
      this.isTryingToDelete = true;
      this.deletableFile = file;
      this.deletableIndex = i;
    },
    deleteFile() {
      this.$api.request
        .delete("files/" + this.deletableFile.id)
        .then(() => {
          this.$delete(this.files, this.deletableIndex);

          if (this.files.length === 0) {
            this.showing = false;
          }
        })
        .finally(() => {
          this.isTryingToDelete = false;
        });
    },
    showFile(file) {
      if (this.showingFile) return;

      this.showingFile = true;

      this.$api.request
        .get(`files/${file.id}`)
        .then((response) => {
          const popup = window.open(response.data.url, "_blank");

          if (popup === null || typeof popup === "undefined") {
            this.$toast.show(
              "Oops! We noticed your pop ups are being blocked. Enable pop ups and try again."
            );
          } else {
            popup.focus();
          }
        })
        .catch(() => {
          this.$toast.show("Ops, something went wrong! Please, try again.");
        })
        .finally(() => {
          this.showingFile = false;
        });
    },

    updateObservation() {
  const reviewId = this.$route.params.id;
  const existingAnswer = this.answers.find(answer => answer.question_id === this.question.id);
  const answerId = existingAnswer ? existingAnswer.id : null;

  if (!answerId) {
    this.$toast.error("Não foi possível encontrar a resposta para atualizar.");
    return;
  }

  const data = {
    text: this.observation,
  };

  this.$api.request
    .put(`/reviews/${reviewId}/answers/${answerId}`, data)
    .then((response) => {
      this.$toast.show("Observação atualizada com sucesso.");
    })
    .catch((error) => {
      if (error.response) {
        console.error('Resposta do servidor:', error.response.data);
        this.$toast.error(`Erro ao atualizar a observação: ${error.response.data.message}`);
      } else {
        this.$toast.error("Erro ao atualizar a observação.");
      }
    });
},


  },
  mounted() {
  this.initializeObservation();

  setTimeout(() => {
    if (this.answers.length > 0) {
      this.files = this.answers
        .filter((answer) => answer.files && answer.files.length > 0)
        .reduce((current, previous) => current.concat(previous.files), []);
    }
  }, 500);
},

watch: {
  answers: {
    handler() {
      this.initializeObservation();
    },
    deep: true
  }
},

};
</script>
